export default {
      id: "briolette-usage",
      viewBox: "0 0 19 30",
      url: __webpack_public_path__ + "icons.svg#briolette",
      toString: function () {
        return this.url;
      }
    }